import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import StartPage from "@/pages/StartPage";
import ClaritySprint from "@/pages/ClaritySprint";
import ResultsPage from "@/pages/ResultsPage";
import AdminPage from "@/pages/AdminPage";
import ReadmePage from "@/pages/ReadmePage";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="min-h-screen bg-background">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<StartPage />} />
          <Route path="/start" element={<StartPage />} />
          <Route path="/sprint" element={<ClaritySprint />} />
          <Route path="/results" element={<ResultsPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/admin/decision-layer" element={<AdminPage />} />
          <Route path="/readme" element={<ReadmePage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
